import { useCallback, useEffect } from 'react';
import { adjustPosition } from '../utils';

export function useAdjustPosition(elementSelector: string, parentSelector: string, deps?: any[], parentPaddings = {}) {
  const update = useCallback(() => {
    if (!elementSelector || !parentSelector) {
      return;
    }

    const element = document.querySelector<HTMLElement>(elementSelector);
    const parent = document.querySelector<HTMLElement>(parentSelector);

    if (element && parent) {
      adjustPosition(element, parent, parentPaddings);
    }
    // eslint-disable-next-line
  }, [elementSelector, parentSelector, parentPaddings]);

  // eslint-disable-next-line
  useEffect(update, deps);

  return update;
}
